<template>
    <sa-page-layout :btnCloseVisible="true" :linkback="linkback" :data="jsonData" :showModalLoading="showModalLoading" :pathResource="pathResource" class="sa-no-space">
        <template slot="table-body">
            <farmacie-view-component :showModalLoading="showModalLoading" @update="onUpdateJsonData" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></farmacie-view-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import FarmacieViewComponent from "../components/FarmacieViewComponent.vue";
export default {
    components: { SaPageLayout, FarmacieViewComponent },
    data() {
        return {
            showModalLoading: false,
            pathResource: "/farmacie",
            linkback: "/farmacie",
            jsonData: {},
        };
    },
    methods: {
        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
        },
        onBeforeLoadData() {},
        onAfterLoadData() {},
    },
};
</script>

<style></style>
